import { BcmOrder, BcmOrderDto } from './bcm-order';
import { BcmFile, BcmFileDto } from './bcm-file';
import { Boat, IBoat } from './boat';
import { OrderAttachmentKind, normalizeOrderAttachmentKind } from '@shared/helpers/order-attachment-kind.util';
import { parseBcmAuditTimestamp } from '@shared/functions/parse-bcm-audit-timestamp';

export interface BcmOrderAttachmentDto {
    id: number;
    bcm_orders_id: number;
    bcm_files_id: number;
    attachmentKind?: OrderAttachmentKind | string | null;
    caption?: string | null;
    transcription_text?: string | null;
    bcm_boats_id?: number | null;
    bcm_order_has_boat_weighings_id?: number | null;
    bcm_order_has_invoice_positions_id?: number | null;
    bcm_order_has_todos_id?: number | null;
    bcm_order_time_entries_id?: number | null;
    insertedOn: Date;
    insertedBy: string;
    lastUpdateOn: Date;
    lastUpdateBy: string;
    order?: BcmOrderDto;
    file: BcmFileDto;
    boat?: IBoat | null;
}

export class BcmOrderAttachment {
    id: number;
    bcm_orders_id: number;
    bcm_files_id: number;
    attachmentKind: OrderAttachmentKind;
    caption: string | null;
    transcription_text: string | null;
    bcm_boats_id: number | null;
    bcm_order_has_boat_weighings_id: number | null;
    bcm_order_has_invoice_positions_id: number | null;
    bcm_order_has_todos_id: number | null;
    bcm_order_time_entries_id: number | null;
    readonly insertedOn: Date;
    readonly insertedBy: string;
    readonly lastUpdateOn: Date;
    readonly lastUpdateBy: string;
    order: BcmOrder | null;
    file: BcmFile | null;
    boat: Boat | null;

    constructor(bcmOrderAttachment: BcmOrderAttachmentDto) {
        this.id = bcmOrderAttachment.id;
        this.bcm_orders_id = bcmOrderAttachment.bcm_orders_id;
        this.bcm_files_id = bcmOrderAttachment.bcm_files_id;
        this.attachmentKind = normalizeOrderAttachmentKind(bcmOrderAttachment.attachmentKind);
        this.caption = bcmOrderAttachment.caption ?? null;
        this.transcription_text = bcmOrderAttachment.transcription_text ?? null;
        this.bcm_boats_id = bcmOrderAttachment.bcm_boats_id ?? null;
        this.bcm_order_has_boat_weighings_id = bcmOrderAttachment.bcm_order_has_boat_weighings_id ?? null;
        this.bcm_order_has_invoice_positions_id = bcmOrderAttachment.bcm_order_has_invoice_positions_id ?? null;
        this.bcm_order_has_todos_id = bcmOrderAttachment.bcm_order_has_todos_id ?? null;
        this.bcm_order_time_entries_id = bcmOrderAttachment.bcm_order_time_entries_id ?? null;
        this.insertedOn = parseBcmAuditTimestamp(bcmOrderAttachment.insertedOn);
        this.insertedBy = bcmOrderAttachment.insertedBy;
        this.lastUpdateOn = parseBcmAuditTimestamp(bcmOrderAttachment.lastUpdateOn);
        this.lastUpdateBy = bcmOrderAttachment.lastUpdateBy;

        this.order = bcmOrderAttachment.order ? new BcmOrder(bcmOrderAttachment.order) : null;
        this.file = bcmOrderAttachment.file ? new BcmFile(bcmOrderAttachment.file) : null;
        this.boat = bcmOrderAttachment.boat ? new Boat(bcmOrderAttachment.boat) : null;
    }
}
